<template>
  <b-row class="vh-100 overflow-y-scroll">
    <b-col v-if="!isMobile" class="bg-lightblue d-flex flex-column justify-content-end align-items-center" cols="0" md="8">
      <img src="@/assets/images/illustrations/bg-justice.png" width="700" />
    </b-col>

    <b-col>
      <div class="d-block text-center mt-50 pt-3 pb-3">
        <b-img :src="require('@/assets/logo/logo-black.svg')" height="60" />
      </div>

      <div :class="{ 'pl-4': isMobile }" class="pr-4">
        <div class="m-auto rounded-lg mt-4" style="max-width: 600px;">
          <login-selection
            v-if="!currentStep"
            @continue-with-email-magiclink="currentStep = AUTH_STEPS.EMAIL_MAGICLINK"
            @continue-with-email-password="currentStep = AUTH_STEPS.EMAIL_PASSWORD"
            @continue-with-google="triggerLoginGoogle"
            :is-loading="isLoading"
          />

          <login-email-magiclink v-else-if="currentStep === AUTH_STEPS.EMAIL_MAGICLINK" @previous="currentStep = null" />
        </div>

        <hr class="mt-5" />

        <login-email-password class="mt-5" v-if="!currentStep" />

        <p class="text-center mt-50 mb-50">
          {{ "Don't have an account yet?" | __t("auth__don-t-have-an-account-yet") }}
          <router-link :to="{ name: 'Register' }">{{ "Sign up now." | __t("auth__headline__register") }}</router-link>
        </p>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LOGIN_BY_GOOGLE } from "@/store/actions";

import { BRow, BCol, BImg } from "bootstrap-vue";

import { AUTH_STEPS } from "@/constants/auth";
import { AUTH_ERROR_MESSAGE } from "@/constants/local-storage";

import LoginSelection from "@/components/Auth/Login/Select";
import LoginEmailMagiclink from "@/components/Auth/Login/EmailMagiclink";
import LoginEmailPassword from "@/components/Auth/Login/EmailPassword";

export default {
  name: "Login",
  components: {
    BRow,
    BCol,
    BImg,
    LoginSelection,
    LoginEmailMagiclink,
    LoginEmailPassword,
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    isMobile() {
      const { value } = this.$screen.alias;
      return value === "xs" || value === "sm" || value === "md";
    },
  },
  data() {
    return {
      currentStep: null,

      isLoading: false,

      AUTH_STEPS,
    };
  },
  created() {
    this.errorMessage = window.localStorage.getItem(AUTH_ERROR_MESSAGE) || null;
    window.localStorage.removeItem(AUTH_ERROR_MESSAGE);
  },
  beforeRouteEnter(_, __, next) {
    next((vm) => {
      if (vm.isAuthenticated) next({ name: "Projects" });
    });
  },
  watch: {
    isAuthenticated() {
      const { isAuthenticated } = this;
      if (isAuthenticated) this.$router.push({ name: "Projects" });
    },
  },
  methods: {
    ...mapActions("auth", { loginByGoogle: LOGIN_BY_GOOGLE }),
    async triggerLoginGoogle() {
      this.isLoading = true;
      this.errorMessage = null;
      const { isSuccess } = await this.loginByGoogle();

      if (!isSuccess) {
        this.errorMessage = "Login failed. Please contact us at hello@legalatlas.ai";
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_settings";

.divider-or {
  text-align: center;
  font-weight: bolder;
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
  span {
    margin: 0 10px;
  }
  &::before,
  &::after {
    content: "";
    display: block;
    height: 2px;
    flex-shrink: 0;
    flex-grow: 1;
  }
}
</style>
